import { Box, Button } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useAutoFocusOnLastOption } from "./hooks/useAutoFocusOnLastOption";
import OptionVariantIndicator from "./OptionVariantIndicator";
import SelectableQuestionOptionRow from "./SelectableQuestionOptionRow";

type Props = {
    optionVariant: string;
};

export default function SelectableQuestionOptionsEditor({ optionVariant }: Props) {
    const { t } = useTranslation("formTemplateEditor");

    const { control } = useFormContext();
    const { fields, remove, append } = useFieldArray({
        control,
        name: "options",
    });

    useAutoFocusOnLastOption(fields);

    return (
        <Box sx={{ display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 1, alignItems: "baseline" }}>
            {fields.map((field, index) => (
                <SelectableQuestionOptionRow
                    key={field.id}
                    optionVariant={optionVariant}
                    index={index}
                    isLastItem={fields.length === 1}
                    onRemove={() => remove(index)}
                />
            ))}
            <OptionVariantIndicator optionVariant={optionVariant} index={fields.length} />
            <Button
                onClick={() => {
                    append({
                        id: crypto.randomUUID(),
                        name: `Option ${fields.length + 1}`,
                    });
                }}
                size="small"
                variant="text"
                sx={theme => ({
                    color: "text.secondary",
                    textTransform: "none",
                    fontSize: theme.typography.subtitle1.fontSize,
                    justifyContent: "flex-start",
                    justifySelf: "flex-start",
                    paddingLeft: 0,
                })}
            >
                {t("formTemplateQuestionForm.btnAddOption")}
            </Button>
            <div />
        </Box>
    );
}
